export default __webpack_public_path__ + "static/media/danny1000.600117ad.jpg";